import { DiscountBreakdownField, IQuoteRespSchema } from '@monetize/types/app';
import { formatCurrency, roundNumberToDecimal } from '@monetize/utils/core';
import { FooterRowAmendV2 } from '../../../../components/Quotes/FooterRowAmendV2';
import { DISCOUNT_BREAKDOWN_ROWS } from '../../../../constants/quotes';

interface QuoteSequentialDiscountBreakdownAmendV2Props {
  incrementalPrices: NonNullable<IQuoteRespSchema['incrementalPrices']>;
  currency: string;
  variableAmountIndicator: string;
}

export const QuoteSequentialDiscountBreakdownAmendV2 = ({
  incrementalPrices,
  currency,
  variableAmountIndicator,
}: QuoteSequentialDiscountBreakdownAmendV2Props) => {
  const getIncrementalValue = (field: DiscountBreakdownField): number =>
    roundNumberToDecimal(
      (incrementalPrices.absolute.discountBreakdown?.[field] ?? 0) -
        (incrementalPrices.prior.discountBreakdown?.[field] ?? 0),
      2,
    );

  const formatAmount = (amount: number) =>
    formatCurrency(amount, { currency }) + variableAmountIndicator;

  return (
    <>
      {DISCOUNT_BREAKDOWN_ROWS.map(({ name, field }) => {
        const absoluteVal =
          incrementalPrices.absolute.discountBreakdown?.[field] ?? 0;
        const priorVal =
          incrementalPrices.prior.discountBreakdown?.[field] ?? 0;

        if (!absoluteVal && !priorVal) {
          return null;
        }

        return (
          <FooterRowAmendV2
            key={name}
            name={name}
            childrenProps={{ fontWeight: 'normal' }}
            value={formatAmount(-absoluteVal)}
            priorValue={formatAmount(-priorVal)}
            amendmentValue={formatAmount(-getIncrementalValue(field))}
          />
        );
      })}
    </>
  );
};
